export default class ApiConfig {


  static apiRoot = process.env.REACT_APP_API_ROOT || 'https://server-production-a29c.up.railway.app';
  static baseUrl = process.env.REACT_APP_BASE_API_URL || 'https://server-production-a29c.up.railway.app';


/*
  static apiRoot = process.env.REACT_APP_API_ROOT || 'http://localhost:5000';
  static baseUrl = process.env.REACT_APP_BASE_API_URL || 'http://localhost:5000';
*/
}
